import CONF from 'config/conf.singleton';
import H from 'constants/httpMethod.const';
import endpoint from 'utils/backend/endpoint.util';
import fromAnyToTrimmed from 'utils/converters/any/fromAnyToTrimmed.util';
import { formatYearToDayStandard } from 'utils/date/format.util';
import actionBe from 'utils/mw/actionBe.util';
import isMissing from 'utils/predicates/any/isMissing.util';

const beGetReconcile = actionBe('beGetReconcile', ({ AT, ATAG, day, desc, pageNumber }) => {
  const options = {
    base: CONF.transactionApiRoot,
    AT,
    name: ATAG,
    params: {
      // eslint-disable-next-line no-nested-ternary
      ord: isMissing(desc) ? void 1 : desc ? '-created' : 'created',
      pag: fromAnyToTrimmed(pageNumber) || void 1,
      day: formatYearToDayStandard(day),
    },
  };

  // NOTE: back end doesn't handle extra parameters, and linkTo utility can't remove them automatically
  // NOTE: keep this long form, so it will be easy to search to projects for get path and see the 3 different results

  if (!isMissing(desc)) {
    return endpoint(H.get, 'cashup/:salonId/reconcile?day=:day&ordering=:ord?', options);
  }

  if (!isMissing(pageNumber)) {
    return endpoint(H.get, 'cashup/:salonId/reconcile?day=:day&page=:pag?', options);
  }

  return endpoint(H.get, 'cashup/:salonId/reconcile?day=:day', options);
});

export default beGetReconcile;
